import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import '../../style/dashboard.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const WarRoomCaption = () => {
    const navigate = useNavigate();
    const { appId, language, userId, userName } = useAppId();

    const lang = language || 'en';

    // Generate WhatsApp message in Gujarati for War Room Captain
    const generateWhatsAppMessage = (captainName) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${captainName}, ${loginUserName} એ તમને વૉર રૂમ કેપ્ટનની જવાબદારી સોંપેલી છે.`;
    };

    // Generate SMS message in Gujarati for War Room Captain
    const generateSMSMessage = (captainName) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${captainName}, ${loginUserName} એ તમને વૉર રૂમ કેપ્ટનની જવાબદારી સોંપેલી છે.`;
    };

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "War Room Captains",
            totalCaptains: "Total Captains",
            noData: "No War Room Captains found.",
            loading: "Loading Data...",
            searchPlaceholder: "Search by name or mobile...",
            addCaptain: "Add War Room Captain",
            sendWhatsapp: "Send Responsibility in Whatsapp",
            sendSMS: "Send Responsibility in SMS",
            status: "Status",
            active: "ACTIVE",
            inactive: "NOT ACTIVE",
            boothLabel: "Booth No. :",
            cancelBtn: "Cancel",
            backBtn: "Back",
            doneBtn: "Done",
            submitBtn: "Add War Room Captain",
            addingBtn: "Adding...",
            updateBtn: "Update Captain",
            updatingBtn: "Updating...",
            nextBtn: "Next: Enter Details",
            addModalTitle: "Add War Room Captain",
            selectBoothsTitle: "Select Booths",
            enterDetailsTitle: "Enter Details",
            editModalTitle: "Edit War Room Captain",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            boothsAssigned: "Booths Assigned",
            selectedLabel: "Selected",
            fillAllFields: "Please fill all details and select at least one booth.",
            nameRequired: "Please enter full name",
            mobileRequired: "Please enter mobile number",
            boothRequired: "Please select at least one booth",
            validMobile: "Please enter a valid 10-digit mobile number",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            addSuccess: "War Room Captain Added Successfully",
            updateSuccess: "Updated successfully!",
            invalidMobile: "Invalid mobile no",
            error: "Error",
            addError: "Error adding captain",
            updateError: "Error updating captain",
            deleteConfirm: "Are you sure you want to delete this War Room Captain?",
            deleteSuccess: "Captain deleted successfully!",
            deleteFailed: "Failed to delete captain.",
            deleteError: "Error deleting captain.",
            userIdMissing: "Error: User ID is missing.",
            viewProfile: "View Profile",
            mobileExists: "Mobile number already exists."
        },
        hi: {
            pageTitle: "वॉर रूम कैप्टन",
            totalCaptains: "कुल कैप्टन",
            noData: "कोई वॉर रूम कैप्टन नहीं मिला।",
            loading: "डेटा लोड हो रहा है...",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            addCaptain: "वॉर रूम कैप्टन जोड़ें",
            sendWhatsapp: "व्हाट्सएप में जिम्मेदारी भेजें",
            sendSMS: "एसएमएस में जिम्मेदारी भेजें",
            status: "स्थिति",
            active: "सक्रिय",
            inactive: "निष्क्रिय",
            boothLabel: "बूथ नंबर :",
            cancelBtn: "रद्द करें",
            backBtn: "वापस",
            doneBtn: "पूर्ण",
            submitBtn: "वॉर रूम कैप्टन जोड़ें",
            addingBtn: "जोड़ा जा रहा है...",
            updateBtn: "कैप्टन अपडेट करें",
            updatingBtn: "अपडेट किया जा रहा है...",
            nextBtn: "अगला: विवरण दर्ज करें",
            addModalTitle: "वॉर रूम कैप्टन जोड़ें",
            selectBoothsTitle: "बूथ चुनें",
            enterDetailsTitle: "विवरण दर्ज करें",
            editModalTitle: "वॉर रूम कैप्टन संपादित करें",
            nameLabel: "पूरा नाम",
            mobileLabel: "मोबाइल नंबर",
            boothsAssigned: "निर्धारित बूथ",
            selectedLabel: "चयनित",
            fillAllFields: "कृपया सभी विवरण भरें और कम से कम एक बूथ चुनें।",
            nameRequired: "कृपया पूरा नाम दर्ज करें",
            mobileRequired: "कृपया मोबाइल नंबर दर्ज करें",
            boothRequired: "कृपया कम से कम एक बूथ चुनें",
            validMobile: "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें।",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            addSuccess: "वॉर रूम कैप्टन सफलतापूर्वक जोड़ा गया",
            updateSuccess: "सफलतापूर्वक अपडेट किया गया!",
            invalidMobile: "अमान्य मोबाइल नंबर",
            error: "त्रुटि",
            addError: "कैप्टन जोड़ने में त्रुटि",
            updateError: "कैप्टन अपडेट करने में त्रुटि",
            deleteConfirm: "क्या आप वाकई इस वॉर रूम कैप्टन को हटाना चाहते हैं?",
            deleteSuccess: "कैप्टन सफलतापूर्वक हटा दिया गया!",
            deleteFailed: "कैप्टन को हटाने में विफल।",
            deleteError: "कैप्टन को हटाने में त्रुटि।",
            userIdMissing: "त्रुटि: उपयोगकर्ता आईडी गायब है।",
            viewProfile: "प्रोफाइल देखें",
            mobileExists: "मोबाइल नंबर पहले से मौजूद है।"
        },
        gu: {
            pageTitle: "વૉર રૂમ કેપ્ટન",
            totalCaptains: "કુલ કેપ્ટન",
            noData: "કોઈ વૉર રૂમ કેપ્ટન મળ્યો નથી.",
            loading: "માહિતી લોડ થઈ રહી છે...",
            searchPlaceholder: "નામ અથવા મોબાઇલ દ્વારા શોધો...",
            addCaptain: "વૉર રૂમ કેપ્ટન ઉમેરો",
            sendWhatsapp: "વોટ્સએપમાં જવાબદારી મોકલો",
            sendSMS: "એસએમએસમાં જવાબદારી મોકલો",
            status: "સ્થિતિ",
            active: "સક્રિય",
            inactive: "નિષ્ક્રિય",
            boothLabel: "બૂથ નંબર :",
            cancelBtn: "રદ કરો",
            backBtn: "પાછળ",
            doneBtn: "પૂર્ણ",
            submitBtn: "વૉર રૂમ કેપ્ટન ઉમેરો",
            addingBtn: "ઉમેરાઈ રહ્યું છે...",
            updateBtn: "કેપ્ટન અપડેટ કરો",
            updatingBtn: "અપડેટ થઈ રહ્યું છે...",
            nextBtn: "આગળ: વિગતો દાખલ કરો",
            addModalTitle: "વૉર રૂમ કેપ્ટન ઉમેરો",
            selectBoothsTitle: "બૂથ પસંદ કરો",
            enterDetailsTitle: "વિગતો દાખલ કરો",
            editModalTitle: "વૉર રૂમ કેપ્ટન સંપાદિત કરો",
            nameLabel: "પૂરું નામ",
            mobileLabel: "મોબાઇલ નંબર",
            boothsAssigned: "સોંપાયેલ બૂથ",
            selectedLabel: "પસંદ કરેલ",
            fillAllFields: "કૃપા કરીને બધી વિગતો ભરો અને ઓછામાં ઓછું એક બૂથ પસંદ કરો.",
            nameRequired: "કૃપા કરીને પૂરું નામ દાખલ કરો",
            mobileRequired: "કૃપા કરીને મોબાઇલ નંબર દાખલ કરો",
            boothRequired: "કૃપા કરીને ઓછામાં ઓછો એક બૂથ પસંદ કરો",
            validMobile: "કૃપા કરીને 10 અંકનો મોબાઇલ નંબર દાખલ કરો.",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            addSuccess: "વૉર રૂમ કેપ્ટન સફળતાપૂર્વક ઉમેરાયું",
            updateSuccess: "સફળતાપૂર્વક અપડેટ થયું!",
            invalidMobile: "અમાન્ય મોબાઇલ નંબર",
            error: "ભૂલ",
            addError: "કેપ્ટન ઉમેરવામાં ભૂલ",
            updateError: "કેપ્ટન અપડેટ કરવામાં ભૂલ",
            deleteConfirm: "શું તમે ખરેખર આ વૉર રૂમ કેપ્ટનને કાઢી નાખવા માંગો છો?",
            deleteSuccess: "કેપ્ટન સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
            deleteFailed: "કેપ્ટન કાઢી નાખવામાં નિષ્ફળ.",
            deleteError: "કેપ્ટન કાઢી નાખવામાં ભૂલ.",
            userIdMissing: "ભૂલ: ઉપયોગકર્તા ID ગુમ થયેલ છે.",
            viewProfile: "પ્રોફાઇલ જુઓ",
            mobileExists: "મોબાઇલ નંબર પહેલેથી જ અસ્તિત્વમાં છે."
        }
    };

    const txt = t[lang] || t.en;

    const [captains, setCaptains] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    // --- Add Captain Modal States ---
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [boothListAPI, setBoothListAPI] = useState([]);
    const [selectedBooths, setSelectedBooths] = useState([]);
    const [modalStep, setModalStep] = useState(1); // 1: Select Booths, 2: Enter Details
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', mobile_no: '' });
    const [mobileError, setMobileError] = useState("");

    // --- Edit Captain State ---
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editModalStep, setEditModalStep] = useState(1);
    const [isEditing, setIsEditing] = useState(false);
    const [editFormData, setEditFormData] = useState({
        user_id: '',
        name: '',
        mobile_no: '',
        booth_list: []
    });
    const [editMobileError, setEditMobileError] = useState("");

    // --- Profile Detail Modal State ---
    const [selectedCaptain, setSelectedCaptain] = useState(null);

    // --- Fetch Data ---
    useEffect(() => {
        if (appId) {
            fetchData();
        }
    }, [appId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_war_pramukh`, {
                app_id: appId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                setCaptains(response.data.data.result);
            } else {
                setCaptains([]);
            }
        } catch (error) {
            console.error("Error fetching war room captains:", error);
            setCaptains([]);
        } finally {
            setLoading(false);
        }
    };

    // --- Fetch Booths for Selection ---
    const handleOpenModal = async () => {
        setIsModalOpen(true);
        setModalStep(1);
        setSelectedBooths([]);
        setFormData({ name: '', mobile_no: '' });
        setMobileError("");
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_booth_list_for_sakti_creation`, {
                app_id: appId,
                type: "WP"
            });
            if (response.data.success) {
                setBoothListAPI(response.data.data.result || []);
            }
        } catch (error) {
            console.error("Error fetching booths:", error);
        }
    };

    const toggleBoothSelection = (boothNo) => {
        const bStr = String(boothNo).trim();
        setSelectedBooths(prev =>
            prev.includes(bStr)
                ? prev.filter(b => b !== bStr)
                : [...prev, bStr]
        );
    };

    // Mobile number validation function
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    const handleMobileChange = (e, isEdit = false) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const limitedValue = numericValue.slice(0, 10);
        
        if (isEdit) {
            setEditFormData(prev => ({ ...prev, mobile_no: limitedValue }));
            if (editMobileError) setEditMobileError("");
            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setEditMobileError(validation.message);
                } else {
                    setEditMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setEditMobileError(txt.mobileLength);
            }
        } else {
            setFormData(prev => ({ ...prev, mobile_no: limitedValue }));
            if (mobileError) setMobileError("");
            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setMobileError(validation.message);
                } else {
                    setMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setMobileError(txt.mobileLength);
            }
        }
    };

    const handleAddCaptain = async (e) => {
        e.preventDefault();
        
        // Specific validation for name
        if (!formData.name || formData.name.trim() === '') {
            alert(txt.nameRequired);
            return;
        }

        // Specific validation for mobile
        if (!formData.mobile_no || formData.mobile_no.trim() === '') {
            alert(txt.mobileRequired);
            return;
        }

        // Specific validation for booth selection
        if (selectedBooths.length === 0) {
            alert(txt.boothRequired);
            return;
        }

        // Mobile number format validation
        const validation = validateMobileNumber(formData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setMobileError(validation.message);
            return;
        }

        setIsSubmitting(true);
        try {
            const formattedBoothList = selectedBooths.join(',') + ",";
            const formattedPrimaryBooth = selectedBooths[0] + ",";

            const payload = {
                app_id: appId,
                name: formData.name,
                mobile_no: formData.mobile_no,
                user_type: "WP",
                booth_no: formattedPrimaryBooth,
                booth_list: formattedBoothList,
                create_by: userId || "Admin"
            };

            const response = await axios.post(`${BASE_URL}/api/insert_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.addSuccess);
                setIsModalOpen(false);
                setFormData({ name: '', mobile_no: '' });
                setMobileError("");
                fetchData();
            } else {
                alert(txt.mobileExists);
            }
        } catch (error) {
            console.error(error);
            alert(txt.addError);
        } finally {
            setIsSubmitting(false);
        }
    };

    const getBoothArray = (boothString) => {
        if (!boothString) return [];
        const rawArray = boothString.split(',').map(b => String(b).trim()).filter(b => b !== '');
        return [...new Set(rawArray)];
    };

    const handleEditClick = async () => {
        if (selectedCaptain) {
            const currentBooths = getBoothArray(selectedCaptain.booth_no);
            setEditFormData({
                user_id: selectedCaptain.user_id || selectedCaptain.id,
                name: selectedCaptain.name,
                mobile_no: selectedCaptain.mobile_no,
                booth_list: currentBooths
            });
            setEditMobileError("");
            setSelectedCaptain(null);
            setEditModalStep(1);
            setIsEditModalOpen(true);

            if (boothListAPI.length === 0) {
                try {
                    const response = await axios.post(`${BASE_URL}/api/dis_booth_list_for_sakti_creation`, {
                        app_id: appId,
                        type: "WP"
                    });
                    if (response.data.success) {
                        setBoothListAPI(response.data.data.result || []);
                    }
                } catch (error) {
                    console.error("Error fetching booths:", error);
                }
            }
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        // Specific validation for name
        if (!editFormData.name || editFormData.name.trim() === '') {
            alert(txt.nameRequired);
            return;
        }

        // Specific validation for mobile
        if (!editFormData.mobile_no || editFormData.mobile_no.trim() === '') {
            alert(txt.mobileRequired);
            return;
        }

        // Specific validation for booth selection
        if (editFormData.booth_list.length === 0) {
            alert(txt.boothRequired);
            return;
        }

        // Mobile number format validation
        const validation = validateMobileNumber(editFormData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setEditMobileError(validation.message);
            return;
        }

        setIsEditing(true);

        const formattedBoothList = editFormData.booth_list.join(',') + ",";
        const formattedPrimaryBooth = editFormData.booth_list[0] + ",";

        const payload = {
            user_id: editFormData.user_id,
            app_id: appId,
            name: editFormData.name,
            mobile_no: editFormData.mobile_no,
            user_type: "WP",
            booth_no: formattedPrimaryBooth,
            booth_list: formattedBoothList,
            create_by: userId || "Admin"
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/update_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.updateSuccess);
                setIsEditModalOpen(false);
                setEditMobileError("");
                fetchData();
            } else {
                alert(response.data.data?.Message || txt.invalidMobile);
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(txt.updateError);
        } finally {
            setIsEditing(false);
        }
    };

    const handleDeleteCaptain = async (id) => {
        if (!id) {
            alert(txt.userIdMissing);
            return;
        }

        if (window.confirm(txt.deleteConfirm)) {
            try {
                const response = await axios.post(`${BASE_URL}/api/dlt_user`, {
                    app_id: appId,
                    user_id: id,
                    delete_by: userId || "Admin"
                });

                if (response.data.success || response.data.Success == "1" || (response.data.data && response.data.data.Success == "1")) {
                    alert(txt.deleteSuccess);
                    setSelectedCaptain(null);
                    fetchData();
                } else {
                    alert(response.data.message || response.data.Message || response.data.data?.Message || txt.deleteFailed);
                }
            } catch (error) {
                console.error("Delete Error:", error);
                alert(txt.deleteError);
            }
        }
    };

    const filteredCaptains = (captains || []).filter(captain => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        return (
            (captain.name && captain.name.toLowerCase().includes(lowerSearch)) ||
            (captain.mobile_no && captain.mobile_no.includes(lowerSearch))
        );
    });

    if (loading) {
        return (
            <div className="loader-wrapper">
                <div className="spinner"></div>
                <p className="loader-text">{txt.loading}</p>
                <style jsx>{`
                    .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                    .spinner { width: 50px; height: 50px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
                    .loader-text { color: #6B7280; font-weight: 500; font-size: 1.1rem; animation: pulse 1.5s ease-in-out infinite; }
                    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                    @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
                `}</style>
            </div>
        );
    }

    return (
        <>
            {/* --- Selection & Add Modal - Premium ShaktiKendra Style --- */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="sk-add-modal">
                        <div className="sk-add-header">
                            <div>
                                <h2 className="sk-add-title">
                                    {modalStep === 1 ? txt.selectBoothsTitle : txt.enterDetailsTitle}
                                </h2>
                            </div>
                            <button className="sk-add-close" onClick={() => setIsModalOpen(false)}>✕</button>
                        </div>

                        {modalStep === 1 ? (
                            <div className="sk-add-body">
                                <div className="sk-add-selected-bar">
                                    <span className="sk-add-selected-label">{txt.selectedLabel}</span>
                                    <span className="sk-add-selected-value">
                                        {selectedBooths.length > 0 ? selectedBooths.join(', ') : '—'}
                                    </span>
                                    <span className="sk-add-selected-count">{selectedBooths.length}</span>
                                </div>

                                <div className="sk-add-booth-grid">
                                    {boothListAPI.map(b => {
                                        const bStr = String(b.booth_no).trim();
                                        const isSelected = selectedBooths.includes(bStr);
                                        return (
                                            <div
                                                key={b.booth_no}
                                                className={`sk-add-booth-tile ${isSelected ? 'selected' : ''}`}
                                                onClick={() => toggleBoothSelection(bStr)}
                                            >
                                                {b.booth_no}
                                                {Number(b.is_assigned) === 1 && <span className="sk-add-assigned-dot"></span>}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="sk-add-footer">
                                    <button
                                        className="sk-add-btn-primary"
                                        onClick={() => setModalStep(2)}
                                        disabled={selectedBooths.length === 0}
                                    >
                                        {txt.nextBtn}
                                        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleAddCaptain} className="sk-add-body">
                                <div className="sk-add-form-group">
                                    <label className="sk-add-label">{txt.nameLabel}</label>
                                    <input
                                        type="text"
                                        className="sk-add-input"
                                        required
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        placeholder={txt.nameLabel}
                                    />
                                </div>

                                <div className="sk-add-form-group">
                                    <label className="sk-add-label">{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        className={`sk-add-input ${mobileError ? 'error' : ''}`}
                                        required
                                        maxLength="10"
                                        value={formData.mobile_no}
                                        onChange={(e) => handleMobileChange(e, false)}
                                        placeholder="9876543210"
                                    />
                                    {mobileError && <div className="sk-add-error-text">{mobileError}</div>}
                                </div>

                                <div className="sk-add-footer sk-add-footer-split">
                                   
                                    <button type="submit" className="sk-add-btn-primary" disabled={isSubmitting} style={{ maxWidth: '200px' }}>
                                        {isSubmitting ? txt.addingBtn : txt.submitBtn}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            )}

            {/* --- Edit Modal - Premium ShaktiKendra Style --- */}
            {isEditModalOpen && (
                <div className="modal-overlay">
                    <div className="sk-edit-modal">
                        <div className="sk-edit-header">
                            <div>
                                <h2 className="sk-edit-title">{txt.editModalTitle}</h2>
                            </div>
                            <button className="sk-edit-close" onClick={() => setIsEditModalOpen(false)}>✕</button>
                        </div>

                        {editModalStep === 1 ? (
                            <form onSubmit={handleUpdateSubmit} className="sk-edit-body">
                                <div className="sk-edit-form-group">
                                    <label className="sk-edit-label">{txt.boothsAssigned}</label>
                                    <button
                                        type="button"
                                        className="sk-edit-booth-summary"
                                        onClick={() => setEditModalStep(2)}
                                    >
                                        <span className="sk-edit-booth-summary-text">
                                            {editFormData.booth_list.length > 0
                                                ? editFormData.booth_list.join(', ')
                                                : 'Select booths'}
                                        </span>
                                        <span className="sk-edit-booth-summary-count">
                                            {editFormData.booth_list.length}
                                        </span>
                                        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>

                                <div className="sk-edit-form-group">
                                    <label className="sk-edit-label">{txt.nameLabel}</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="sk-edit-input"
                                        value={editFormData.name}
                                        onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
                                        required
                                        placeholder={txt.nameLabel}
                                    />
                                </div>

                                <div className="sk-edit-form-group">
                                    <label className="sk-edit-label">{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        className={`sk-edit-input ${editMobileError ? 'error' : ''}`}
                                        value={editFormData.mobile_no}
                                        onChange={(e) => handleMobileChange(e, true)}
                                        maxLength="10"
                                        required
                                        placeholder="9876543210"
                                    />
                                    {editMobileError && <div className="sk-edit-error-text">{editMobileError}</div>}
                                </div>

                                <div className="sk-edit-footer">
                                    <button type="submit" className="sk-edit-btn-primary" disabled={isEditing}>
                                        {isEditing ? txt.updatingBtn : txt.updateBtn}
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <div className="sk-edit-body">
                                <div className="sk-edit-selected-bar">
                                    <span className="sk-edit-selected-label">{txt.selectedLabel}</span>
                                    <span className="sk-edit-selected-value">
                                        {editFormData.booth_list.length > 0 ? editFormData.booth_list.join(', ') : '—'}
                                    </span>
                                    <span className="sk-edit-selected-count">{editFormData.booth_list.length}</span>
                                </div>

                                <div className="sk-edit-booth-grid">
                                    {boothListAPI.map(b => {
                                        const bStr = String(b.booth_no).trim();
                                        const isSelected = editFormData.booth_list.includes(bStr);
                                        return (
                                            <div
                                                key={b.booth_no}
                                                className={`sk-edit-booth-tile ${isSelected ? 'selected' : ''}`}
                                                onClick={() => setEditFormData(prev => ({
                                                    ...prev,
                                                    booth_list: isSelected
                                                        ? prev.booth_list.filter(x => x !== bStr)
                                                        : [...prev.booth_list, bStr]
                                                }))}
                                            >
                                                {b.booth_no}
                                                {Number(b.is_assigned) === 1 && <span className="sk-edit-assigned-dot"></span>}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="sk-edit-footer">
                                    <button className="sk-edit-btn-primary" onClick={() => setEditModalStep(1)}>
                                        {txt.doneBtn}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* --- Profile Detail Modal (Same as ShaktiKendra) --- */}
            {selectedCaptain && (
                <div className="modal-overlay" onClick={() => setSelectedCaptain(null)}>
                    <div className="profile-detail-container" onClick={(e) => e.stopPropagation()}>
                        <button className="profile-close-btn" onClick={() => setSelectedCaptain(null)}>
                            <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <div className="profile-detail-card">
                            <div className="profile-avatar-wrapper">
                                <div className="profile-avatar-bg">
                                    <img src={selectedCaptain.photo_path || selectedCaptain.photo || `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedCaptain.name)}&background=e5e5e5&color=a3a3a3`} alt={selectedCaptain.name} />
                                </div>
                            </div>
                            <div className="profile-content">
                                <h2 className="profile-name">{selectedCaptain.name}</h2>
                                <p className="profile-mobile">{selectedCaptain.mobile_no}</p>
                                <div className="profile-big-btns">
                                    <a href={`https://wa.me/91${selectedCaptain.mobile_no}?text=${encodeURIComponent(generateWhatsAppMessage(selectedCaptain.name))}`} target="_blank" rel="noreferrer" className="btn-resp btn-wa">
                                        {txt.sendWhatsapp}
                                    </a>
                                    <a href={`sms:${selectedCaptain.mobile_no}?body=${encodeURIComponent(generateSMSMessage(selectedCaptain.name))}`} className="btn-resp btn-sms-big">
                                        {txt.sendSMS}
                                    </a>
                                </div>
                            </div>
                            <div className="profile-bottom-bar" style={{ display: 'flex', justifyContent: 'space-evenly', background: '#213555', padding: '10px', borderRadius: '0 0 20px 20px' }}>
                                <a href={`tel:${selectedCaptain.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#0ea5e9' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                        </svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`https://wa.me/91${selectedCaptain.mobile_no}`} target="_blank" rel="noreferrer" className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#22c55e' }}>
                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                                        </svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`sms:${selectedCaptain.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#3b82f6', position: 'relative' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z"/>
                                        </svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={handleEditClick} style={{ background: 'none', border: 'none', padding: 0 }}>
                                    <div className="icon-transparent" style={{ color: '#f59e0b' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={() => handleDeleteCaptain(selectedCaptain.user_id || selectedCaptain.id)} style={{ background: 'none', border: 'none', padding: 0 }}>
                                    <div className="icon-transparent" style={{ color: '#ef4444' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .filter-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                    background: transparent;
                }

                .action-group {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .mobile-search-trigger {
                    display: none;
                }
                .close-search-btn {
                    display: none;
                }

                .search-wrapper {
                    position: relative;
                    flex: 1;
                    max-width: 400px;
                }

                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 42px;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #1e293b;
                    background-color: #ffffff;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }

                .search-input:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                .btn-add-user {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background-color: #2563eb;
                    color: #ffffff;
                    padding: 12px 20px;
                    border: none;
                    border-radius: 10px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
                    white-space: nowrap;
                }

                .btn-add-user:hover {
                    background-color: #1d4ed8;
                    transform: translateY(-1px);
                    box-shadow: 0 6px 8px -1px rgba(37, 99, 235, 0.3);
                }

                .total-count-display {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    padding: 8px 0;
                    margin-bottom: 16px;
                }
                .total-count-text {
                    font-size: 0.9rem;
                    font-weight: 500;
                    color: #475569;
                    background: #f1f5f9;
                    padding: 6px 14px;
                    border-radius: 20px;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                }

                @media (max-width: 640px) {
                    .filter-container {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 12px;
                    }
                    
                    .search-wrapper {
                        display: none;
                        width: 100%;
                        max-width: 100%;
                    }
                    
                    .search-wrapper.mobile-open {
                        display: block;
                    }

                    .search-input {
                        padding-right: 40px;
                    }

                    .close-search-btn {
                        display: block;
                        position: absolute;
                        right: 8px;
                        top: 50%;
                        transform: translateY(-50%);
                        background: #f1f5f9;
                        border: none;
                        color: #64748b;
                        padding: 4px;
                        border-radius: 50%;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .action-group {
                        width: 100%;
                    }

                    .btn-add-user {
                        flex: 1;
                        height: 46px;
                    }

                    .mobile-search-trigger {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: white;
                        border: 1px solid #e2e8f0;
                        border-radius: 10px;
                        width: 46px;
                        height: 46px;
                        color: #64748b;
                        cursor: pointer;
                        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                        flex-shrink: 0;
                    }
                }

                .blur-background {
                    filter: blur(4px);
                    pointer-events: none;
                }

                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                    padding: 20px;
                    box-sizing: border-box;
                }

                .profile-detail-container {
                    position: relative;
                    width: 100%;
                    max-width: 380px;
                    margin-top: 50px;
                }
                .profile-close-btn {
                    position: absolute;
                    top: -40px;
                    right: -10px;
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 5px;
                    z-index: 10;
                }
                .profile-detail-card {
                    background: white;
                    border-radius: 20px;
                    display: flex;
                    flex-direction: column;
                    overflow: visible;
                    box-shadow: 0 15px 35px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper {
                    display: flex;
                    justify-content: center;
                    margin-top: -55px;
                }
                .profile-avatar-bg {
                    width: 110px;
                    height: 110px;
                    background: white;
                    border-radius: 50%;
                    padding: 6px;
                }
                .profile-avatar-bg img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }
                .profile-content {
                    padding: 15px 24px 25px 24px;
                    text-align: center;
                }
                .profile-name {
                    font-size: 22px;
                    font-weight: 800;
                    color: #111827;
                    text-transform: uppercase;
                    margin: 0;
                }
                .profile-mobile {
                    font-size: 16px;
                    color: #374151;
                    margin: 8px 0 24px 0;
                    letter-spacing: 0.5px;
                    font-weight: 500;
                }
                .profile-big-btns {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                .btn-resp {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    width: 100%;
                    padding: 14px;
                    border-radius: 50px;
                    color: white;
                    font-weight: 600;
                    text-decoration: none;
                    font-size: 15px;
                    transition: transform 0.2s, box-shadow 0.2s;
                    border: none;
                    box-sizing: border-box;
                }
                .btn-resp:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
                    color: white;
                }
                .btn-wa {
                    background-color: #4ade80;
                }
                .btn-sms-big {
                    background-color: #f59e0b;
                }
                .profile-bottom-bar {
                    background-color: #213555;
                    border-radius: 0 0 20px 20px;
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                }
                .divider {
                    width: 1px;
                    height: 24px;
                    background-color: rgba(255, 255, 255, 0.3);
                }
                .btm-icon-wrapper {
                    background: none;
                    border: none;
                    padding: 8px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: transform 0.2s;
                }
                .btm-icon-wrapper:hover {
                    transform: scale(1.1);
                }
                .icon-transparent {
                    width: 36px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .captain-card {
                    background: #ffffff;
                    border-radius: 16px;
                    border: 1px solid #e2e8f0;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.02);
                    padding: 20px;
                    transition: all 0.2s ease;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    cursor: pointer;
                }
                .captain-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.06);
                    border-color: #cbd5e1;
                }

                .captain-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 16px;
                    padding-bottom: 16px;
                    border-bottom: 1px dashed #e2e8f0;
                }

                .avatar-wrapper {
                    position: relative;
                    width: 54px;
                    height: 54px;
                    flex-shrink: 0;
                }
                .captain-avatar {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
                    color: white;
                    font-size: 22px;
                    font-weight: 700;
                }
                .captain-avatar img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .avatar-initial {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    font-weight: 700;
                }
                .status-dot {
                    position: absolute;
                    bottom: 2px;
                    right: 2px;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    border: 3px solid #ffffff;
                    z-index: 10;
                }
                .status-dot.online { background-color: #22c55e; }
                .status-dot.offline { background-color: #ef4444; }

                .captain-info {
                    flex-grow: 1;
                }
                .captain-name {
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #0f172a;
                    margin: 0 0 6px 0;
                }
                .captain-phone {
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #475569;
                    display: flex;
                    align-items: center;
                    margin-bottom: 6px;
                }

                .status-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                }
                .status-badge.active {
                    background: #dcfce7;
                    color: #166534;
                }
                .status-badge.inactive {
                    background: #fee2e2;
                    color: #991b1b;
                }
                .status-dot-small {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: currentColor;
                }

                .action-btn {
                    background: #f1f5f9;
                    border: none;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-size: 18px;
                    font-weight: bold;
                }

                .booth-badges {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                }
                .booth-badge {
                    background: #f1f5f9;
                    color: #334155;
                    font-size: 0.85rem;
                    font-weight: 700;
                    padding: 6px 12px;
                    border-radius: 8px;
                    border: 1px solid #e2e8f0;
                }

                .empty-state-card {
                    background: white;
                    border-radius: 16px;
                    padding: 40px;
                    border: 1px dashed #cbd5e1;
                    text-align: center;
                }
                .empty-icon {
                    font-size: 40px;
                    margin-bottom: 16px;
                }

                .slide-up-element { 
                    animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
                }
                @keyframes slideUp { 
                    from { opacity: 0; transform: translateY(20px); } 
                    to { opacity: 1; transform: translateY(0); } 
                }

                @media (max-width: 768px) {
                    .profile-detail-container { max-width: 320px; }
                    .profile-avatar-bg { width: 90px; height: 90px; }
                    .profile-name { font-size: 18px; }
                    .profile-content { padding: 15px 16px 20px 16px; }
                    .btn-resp { font-size: 13px; padding: 12px; }
                }

                /* --- Premium Add Shakti Kendra Modal --- */
                .sk-add-modal {
                    background: #ffffff;
                    border-radius: 18px;
                    width: 100%;
                    max-width: 600px;
                    box-shadow: 0 20px 60px -12px rgba(15, 23, 42, 0.25), 0 4px 12px rgba(15, 23, 42, 0.08);
                    overflow: hidden;
                    border: 1px solid rgba(226, 232, 240, 0.8);
                }

                .sk-add-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 24px 26px 18px 26px;
                    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
                    border-bottom: 1px solid #eef1f6;
                }

                .sk-add-title {
                    margin: 0;
                    font-size: 20px;
                    font-weight: 700;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                }

                .sk-add-close {
                    background: #f1f5f9;
                    border: none;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    color: #64748b;
                    cursor: pointer;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.15s ease;
                    flex-shrink: 0;
                }

                .sk-add-close:hover {
                    background: #e2e8f0;
                    color: #0f172a;
                }

                .sk-add-body {
                    padding: 20px 26px 26px 26px;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .sk-add-selected-bar {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    background: #f8fafc;
                    border: 1px solid #eef1f6;
                    border-radius: 12px;
                    padding: 12px 14px;
                }

                .sk-add-selected-label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #64748b;
                    white-space: nowrap;
                }

                .sk-add-selected-value {
                    font-size: 13px;
                    font-weight: 600;
                    color: #0f172a;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    flex: 1;
                }

                .sk-add-selected-count {
                    background: #2563eb;
                    color: white;
                    font-size: 12px;
                    font-weight: 700;
                    min-width: 22px;
                    height: 22px;
                    border-radius: 11px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 6px;
                }

                .sk-add-booth-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
                    gap: 8px;
                    max-height: 300px;
                    overflow-y: auto;
                    padding: 4px 2px;
                }

                .sk-add-booth-tile {
                    padding: 11px 6px;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 10px;
                    text-align: center;
                    cursor: pointer;
                    font-weight: 700;
                    font-size: 13px;
                    color: #334155;
                    background: #ffffff;
                    position: relative;
                    transition: all 0.15s ease;
                }

                .sk-add-booth-tile:hover {
                    border-color: #93c5fd;
                    transform: translateY(-1px);
                }

                .sk-add-booth-tile.selected {
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    border-color: #1d4ed8;
                    color: white;
                    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
                }

                .sk-add-assigned-dot {
                    position: absolute;
                    bottom: 5px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background: #22c55e;
                }

                .sk-add-booth-tile.selected .sk-add-assigned-dot {
                    background: #bbf7d0;
                }

                .sk-add-form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 7px;
                }

                .sk-add-label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #334155;
                }

                .sk-add-input {
                    padding: 12px 14px;
                    border-radius: 10px;
                    border: 1.5px solid #e2e8f0;
                    font-size: 14px;
                    color: #0f172a;
                    outline: none;
                    transition: all 0.15s ease;
                    background: #f8fafc;
                }

                .sk-add-input:focus {
                    border-color: #2563eb;
                    background: #ffffff;
                    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
                }

                .sk-add-input.error {
                    border-color: #ef4444;
                    background: #fef2f2;
                }

                .sk-add-error-text {
                    font-size: 12px;
                    font-weight: 500;
                    color: #ef4444;
                }

                .sk-add-footer {
                    display: flex;
                    justify-content: flex-end;
                    margin-top: 6px;
                }

                .sk-add-footer-split {
                    justify-content: space-between;
                }

                .sk-add-btn-primary {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    color: white;
                    border: none;
                    padding: 13px 22px;
                    border-radius: 11px;
                    font-weight: 600;
                    font-size: 14px;
                    cursor: pointer;
                    width: 100%;
                    box-shadow: 0 6px 16px -4px rgba(37, 99, 235, 0.4);
                    transition: all 0.15s ease;
                }

                .sk-add-footer-split .sk-add-btn-primary {
                    width: auto;
                    flex: 1;
                }

                .sk-add-btn-primary:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 8px 20px -4px rgba(37, 99, 235, 0.5);
                }

                .sk-add-btn-primary:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    box-shadow: none;
                }

                .sk-add-btn-ghost {
                    background: #f1f5f9;
                    color: #334155;
                    border: none;
                    padding: 13px 20px;
                    border-radius: 11px;
                    font-weight: 600;
                    font-size: 14px;
                    cursor: pointer;
                    transition: all 0.15s ease;
                }

                .sk-add-btn-ghost:hover {
                    background: #e2e8f0;
                }

                @media (max-width: 640px) {
                    .sk-add-header { padding: 20px 18px 14px 18px; }
                    .sk-add-body { padding: 16px 18px 20px 18px; }
                    .sk-add-title { font-size: 18px; }
                }

                /* --- Premium Edit Shakti Kendra Modal --- */
                .sk-edit-modal {
                    background: #ffffff;
                    border-radius: 18px;
                    width: 100%;
                    max-width: 500px;
                    box-shadow: 0 20px 60px -12px rgba(15, 23, 42, 0.25), 0 4px 12px rgba(15, 23, 42, 0.08);
                    overflow: hidden;
                    border: 1px solid rgba(226, 232, 240, 0.8);
                }

                .sk-edit-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 24px 26px 18px 26px;
                    background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
                    border-bottom: 1px solid #eef1f6;
                }

                .sk-edit-title {
                    margin: 0;
                    font-size: 20px;
                    font-weight: 700;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                }

                .sk-edit-close {
                    background: #f1f5f9;
                    border: none;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    color: #64748b;
                    cursor: pointer;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.15s ease;
                    flex-shrink: 0;
                }

                .sk-edit-close:hover {
                    background: #e2e8f0;
                    color: #0f172a;
                }

                .sk-edit-body {
                    padding: 22px 26px 26px 26px;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .sk-edit-form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 7px;
                }

                .sk-edit-label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #334155;
                }

                .sk-edit-input {
                    padding: 12px 14px;
                    border-radius: 10px;
                    border: 1.5px solid #e2e8f0;
                    font-size: 14px;
                    color: #0f172a;
                    outline: none;
                    transition: all 0.15s ease;
                    background: #f8fafc;
                }

                .sk-edit-input:focus {
                    border-color: #1e3a8a;
                    background: #ffffff;
                    box-shadow: 0 0 0 4px rgba(30, 58, 138, 0.1);
                }

                .sk-edit-input.error {
                    border-color: #ef4444;
                    background: #fef2f2;
                }

                .sk-edit-error-text {
                    font-size: 12px;
                    font-weight: 500;
                    color: #ef4444;
                }

                .sk-edit-booth-summary {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 12px 14px;
                    border-radius: 10px;
                    border: 1.5px solid #e2e8f0;
                    background: #f8fafc;
                    cursor: pointer;
                    text-align: left;
                    color: #64748b;
                    transition: all 0.15s ease;
                }

                .sk-edit-booth-summary:hover {
                    border-color: #93c5fd;
                    background: #ffffff;
                }

                .sk-edit-booth-summary-text {
                    flex: 1;
                    font-size: 13px;
                    font-weight: 600;
                    color: #0f172a;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .sk-edit-booth-summary-count {
                    background: #1e3a8a;
                    color: white;
                    font-size: 12px;
                    font-weight: 700;
                    min-width: 22px;
                    height: 22px;
                    border-radius: 11px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 6px;
                    flex-shrink: 0;
                }

                .sk-edit-selected-bar {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    background: #f8fafc;
                    border: 1px solid #eef1f6;
                    border-radius: 12px;
                    padding: 12px 14px;
                }

                .sk-edit-selected-label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #64748b;
                    white-space: nowrap;
                }

                .sk-edit-selected-value {
                    font-size: 13px;
                    font-weight: 600;
                    color: #0f172a;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    flex: 1;
                }

                .sk-edit-selected-count {
                    background: #1e3a8a;
                    color: white;
                    font-size: 12px;
                    font-weight: 700;
                    min-width: 22px;
                    height: 22px;
                    border-radius: 11px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 6px;
                }

                .sk-edit-booth-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
                    gap: 8px;
                    max-height: 350px;
                    overflow-y: auto;
                    padding: 4px 2px;
                }

                .sk-edit-booth-tile {
                    padding: 11px 6px;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 10px;
                    text-align: center;
                    cursor: pointer;
                    font-weight: 700;
                    font-size: 13px;
                    color: #334155;
                    background: #ffffff;
                    position: relative;
                    transition: all 0.15s ease;
                }

                .sk-edit-booth-tile:hover {
                    border-color: #93c5fd;
                    transform: translateY(-1px);
                }

                .sk-edit-booth-tile.selected {
                    background: linear-gradient(135deg, #1e3a8a, #1e40af);
                    border-color: #1e3a8a;
                    color: white;
                    box-shadow: 0 4px 10px rgba(30, 58, 138, 0.3);
                }

                .sk-edit-assigned-dot {
                    position: absolute;
                    bottom: 5px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background: #22c55e;
                }

                .sk-edit-booth-tile.selected .sk-edit-assigned-dot {
                    background: #bbf7d0;
                }

                .sk-edit-footer {
                    display: flex;
                    margin-top: 6px;
                }

                .sk-edit-btn-primary {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background: linear-gradient(135deg, #1e3a8a, #1e40af);
                    color: white;
                    border: none;
                    padding: 13px 22px;
                    border-radius: 11px;
                    font-weight: 600;
                    font-size: 14px;
                    cursor: pointer;
                    width: 100%;
                    box-shadow: 0 6px 16px -4px rgba(30, 58, 138, 0.4);
                    transition: all 0.15s ease;
                }

                .sk-edit-btn-primary:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 8px 20px -4px rgba(30, 58, 138, 0.5);
                }

                .sk-edit-btn-primary:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    box-shadow: none;
                }

                @media (max-width: 640px) {
                    .sk-edit-header { padding: 20px 18px 14px 18px; }
                    .sk-edit-body { padding: 18px 18px 22px 18px; }
                    .sk-edit-title { font-size: 18px; }
                }
            `}</style>

            <div className={`app-container p-4 ${isModalOpen || isEditModalOpen || selectedCaptain ? 'blur-background' : ''}`}>
                <Header title={txt.pageTitle} />

                <div className="filter-container">
                    <div className={`search-wrapper ${isMobileSearchOpen ? 'mobile-open' : ''}`}>
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button className="close-search-btn" onClick={() => { setIsMobileSearchOpen(false); setSearchTerm(''); }}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="action-group">
                        {!isMobileSearchOpen && (
                            <button className="mobile-search-trigger" onClick={() => setIsMobileSearchOpen(true)}>
                                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </button>
                        )}
                        <button className="btn-add-user" onClick={handleOpenModal}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            {txt.addCaptain}
                        </button>
                    </div>
                </div>

                <div className="total-count-display slide-up-element" style={{ animationDelay: '0.05s' }}>
                    <span className="total-count-text">
                        📊 {txt.totalCaptains} : {filteredCaptains.length}
                    </span>
                </div>

                <div className="list-section">
                    <div className="row g-4">
                        {filteredCaptains.length > 0 ? (
                            filteredCaptains.map((captain) => {
                                const isActive = captain.last_login !== null;
                                const boothList = getBoothArray(captain.booth_no);

                                return (
                                    <div
                                        key={captain.user_id}
                                        className="col-12 col-md-6 col-xl-4"
                                        onClick={() => navigate('/dis_booth_captain_by_warroom_pramukh', { state: { userId: captain.user_id } })}
                                    >
                                        <div className="captain-card h-100" style={{ cursor: 'pointer' }}>
                                            <div className="captain-header">
                                                <div className="avatar-wrapper">
                                                    <div className="captain-avatar">
                                                        {captain.photo_path || captain.photo ? (
                                                            <img src={captain.photo_path || captain.photo} alt={captain.name} />
                                                        ) : (
                                                            <span className="avatar-initial">{captain.name ? captain.name.charAt(0).toUpperCase() : 'U'}</span>
                                                        )}
                                                    </div>
                                                    <span className={`status-dot ${isActive ? 'online' : 'offline'}`}></span>
                                                </div>
                                                <div className="captain-info">
                                                    <h3 className="captain-name text-black">{captain.name}</h3>
                                                    <div className="captain-phone">
                                                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: '6px', color: '#64748b' }}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                        </svg>
                                                        {captain.mobile_no}
                                                    </div>
                                                    
                                                </div>
                                                <div className="card-right">
                                                    <button className="action-btn" onClick={(e) => { e.stopPropagation(); setSelectedCaptain(captain); }}>⋮</button>
                                                </div>
                                            </div>

                                            <div className="captain-body">
                                                <span className="booth-label">{txt.boothLabel}</span>
                                                <div className="booth-badges">
                                                    {boothList.map((booth, idx) => (
                                                        <span key={idx} className="booth-badge">{booth}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-12">
                                <div className="empty-state-card text-center slide-up-element" style={{ animationDelay: '0.1s' }}>
                                    <div className="empty-icon">🛡️</div>
                                    <h4>{searchTerm ? `No captains found matching "${searchTerm}"` : txt.noData}</h4>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default WarRoomCaption;